import { tableAnatomy as parts } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
const {
  definePartsStyle,
  defineMultiStyleConfig
} = createMultiStyleConfigHelpers(parts.keys);
const baseStyle = () => definePartsStyle({
  thead: {
    backgroundColor: 'GREYSCALE.SUPERNOVA'
  }
});
export const tableTheme = defineMultiStyleConfig({
  baseStyle
});